import { render, staticRenderFns } from "./VerificationCodeEmployer.vue?vue&type=template&id=50270551&scoped=true"
import script from "./VerificationCodeEmployer.vue?vue&type=script&lang=js"
export * from "./VerificationCodeEmployer.vue?vue&type=script&lang=js"
import style0 from "./VerificationCodeEmployer.vue?vue&type=style&index=0&id=50270551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50270551",
  null
  
)

export default component.exports